import { MenuButton } from '@driftt/dds'
import { Button } from '@driftt/dds'
import PlaybookCreatorModal from '@driftt/playbook-creator-modal'
import { receiveUserSettings } from '@driftt/traffic-control'
import { pathOr } from 'ramda'
import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'

import './style.css'

const PB_TYPES = {
  chat: 'CHAT',
  email: 'EMAIL',
  fastlane: 'FASTLANE',
  sequence: 'MARKETING_SEQUENCE',
  meeting: 'MEETING_BOOKING_BOT',
}

const mapStateToProps = (state) => ({
  gates: pathOr({}, ['user', 'gates'], state),
  userId: pathOr(null, ['user', 'id'], state),
  integrationStatus: pathOr({}, ['integrations', 'status'], state),
})

const mapDispatchToProps = (dispatch) => ({
  onReceiveUserSettings: (settings) => {
    dispatch(receiveUserSettings(settings))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(function Marketplace({
  hasAnyPlaybookAccess,
  gates,
  integrationStatus,
  pathname,
}) {
  const [isMarketplaceOpen, setIsMarketplaceOpen] = useState(false)
  const [selectedPlaybookType, setSelectedPlaybookType] = useState(null)

  const showActionDropdown = pathname === 'chat'

  const toggleMarketplace = () => setIsMarketplaceOpen((open) => !open)

  const handleOnButtonClick = () => {
    setSelectedPlaybookType(PB_TYPES[pathname.toLowerCase()] || 'CHAT')
    toggleMarketplace()
  }

  const renderButtonText = () => {
    if (hasAnyPlaybookAccess) {
      return `Create ${pathname} playbook`
    }

    return 'Create sequence'
  }

  const renderCreatePlaybookButton = () => {
    return <Button onClick={handleOnButtonClick}>{renderButtonText()}</Button>
  }

  return (
    <>
      {showActionDropdown && (
        <MenuButton
          className="create-playbook-dropdown"
          buttonText="Create chat playbook"
          options={[
            {
              name: 'Bot / live chat',
              action: (hideDropdown) => {
                setSelectedPlaybookType('CHAT')
                toggleMarketplace()
              },
            },
            {
              name: 'Landing page',
              action: (hideDropdown) => {
                setSelectedPlaybookType('CLP')
                toggleMarketplace()
              },
            },
          ]}
        />
      )}
      {!showActionDropdown &&
        pathname !== 'sequence' &&
        renderCreatePlaybookButton()}

      {isMarketplaceOpen &&
        ReactDOM.createPortal(
          <PlaybookCreatorModal
            onClose={toggleMarketplace}
            gates={gates}
            integrationStatus={integrationStatus}
            playbookType={selectedPlaybookType}
          />,
          document.getElementById('pew-modal-root')
        )}
    </>
  )
})
